import React from 'react';
import './CommentComponent.scss';
import { formatDate } from '../../../helpers/functions';
import FileIcon from '../../../assets/image/file_icon.png';

const CommentComponent = ({ data, onFileClick, action }) => {
    return (
        <div className='comment-component'>
            <div className="comment-component__header comment-component-header">
                <div className="comment-component-header__title">{data.from_user}</div>
                <div className="comment-component-header__right">
                  <div className="comment-component-header__date date_wrapper">{formatDate(data.pub_date)}</div>
                  {action && <div className="comment-component-header__action">{action}</div>}
                </div>
            </div>
            <div className="comment-component__body">
                <div>{data.message}</div>
                {data.files && data.files.length > 0 && (
                  <div className="comment-files">
                    {data.files.map((file, idx) => (
                      <div
                        className="file_add"
                        key={idx}
                        onClick={() => onFileClick && onFileClick(file.file)}
                      >
                        <img src={FileIcon} alt="FileIcon" />
                        <span>{file.name}</span>
                      </div>
                    ))}
                  </div>
                )}
            </div>
        </div>
    );
};

export default CommentComponent;